module.exports = __webpack_public_path__ + "img/banner.454d2759.png";